
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/[categorySlug]",
      function () {
        return require("private-next-pages/promocoes/[categorySlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/[categorySlug]"])
      });
    }
  